export function formatGender(gender) {
  switch (gender?.toLowerCase()) {
    case "male":
      return "Laki - Laki";
    case "female":
      return "Perempuan";
    default:
      return "-";
  }
}
